// extracted by mini-css-extract-plugin
export default {"cls1":"QagW0_mkQ9EKlCAKWt4J","cls2":"GoF5GB70sNqhPHoGmgWB QagW0_mkQ9EKlCAKWt4J","isTabletUp":"vp57TxMIFNtIahbfcQEY"};